import React from "react";
import ReactJson from "react-json-view";

class JsonViewer extends React.Component {
  renderJson = () => {
    const jsonData = JSON.parse(this.props.value);

    return jsonData;
  };

  render() {
    let {collapsed} = this.props

    return (
      <React.Fragment>
        <ReactJson
          name={this.props.name}
          src={this.renderJson()}
          theme="bright:inverted"
          displayDataTypes={false}
          displayObjectSize={false}
          collapsed={collapsed ? collapsed:2}
          iconStyle={"circle"}
          enableClipboard={false}
        />
      </React.Fragment>
    );
  }
}

export default JsonViewer;



// WEBPACK FOOTER //
// ./src/components/utilities/tabs/jsonViewer.js